
export default {
	init() {
		const slider = $('.list-work');
		slider.slick({
			infinite: true,
			verticalSwiping:true,
			vertical: true,
			centerMode: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplaySpeed: 4000,
		});

		slider.on('wheel', (function(e) {
			e.preventDefault();

			if (e.originalEvent.deltaY < 0) {
				$(this).slick('slickPrev');
			} else {
				$(this).slick('slickNext');
			}
		}));
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/pageWorks.js